/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ResultsPreviewRequestDTO { 
    clientId: number;
    brandId: number;
    viewBy: ResultsPreviewRequestDTO.ViewByEnum;
    resultsViewBy?: ResultsPreviewRequestDTO.ResultsViewByEnum;
    conversionType: string;
    dateStart: string;
    dateStop: string;
    segments: Array<string>;
    channels: Array<string>;
    tactics: Array<string>;
}
export namespace ResultsPreviewRequestDTO {
    export type ViewByEnum = 'ROAS' | 'CPO';
    export const ViewByEnum = {
        Roas: 'ROAS' as ViewByEnum,
        Cpo: 'CPO' as ViewByEnum
    };
    export type ResultsViewByEnum = 'LATEST' | 'AGGREGATED';
    export const ResultsViewByEnum = {
        Latest: 'LATEST' as ResultsViewByEnum,
        Aggregated: 'AGGREGATED' as ResultsViewByEnum
    };
}


